import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ProjectsService } from '../services/projects/projects.service';
import { ErrorHandlerService } from '../services/shared/error-handler.service';
import swal from 'sweetalert2';
import { ImageZoomService } from '../shared/image-zoom/image-zoom.service';

@Component({
  selector: 'app-layout-dialog',
  templateUrl: './layout-dialog.component.html',
  styleUrls: ['./layout-dialog.component.css']
})
export class LayoutDialogComponent implements OnInit {
  unit_details: any;
  currentSlide: number;
  loading_unit_data: boolean;
  userInfo: any

  constructor(private dialogRef: MatDialogRef<LayoutDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private imageZoomService: ImageZoomService) {
    this.unit_details = data;
    this.currentSlide = 0;
  }

  ngOnInit() {}


  changeSlide(n) {
    if (n > this.unit_details.layout_images.length - 1) {
      this.currentSlide = 0;
    } else if (n < 0) {
      this.currentSlide = this.unit_details.layout_images.length - 1;
    } else {
      this.currentSlide = n;
    }
  }

  openimageZoom(img) {
    this.imageZoomService.open(img);
  }

  close() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/layout-dialog/layout-dialog.component.ts